import { render, staticRenderFns } from "./users.vue?vue&type=template&id=15fa4aa3&scoped=true&lang=html&"
import script from "./users.vue?vue&type=script&lang=ts&"
export * from "./users.vue?vue&type=script&lang=ts&"
import style0 from "./users.vue?vue&type=style&index=0&id=15fa4aa3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fa4aa3",
  null
  
)

export default component.exports